import React from 'react';
import Markdown from 'markdown-to-jsx';
import { FdOutload } from '@qodly/icons';
import cn from 'classnames';

interface ITextTipProps {
  body: string;
  isInsideCarousel?: boolean;
}

const TextTip: React.FC<ITextTipProps> = ({ body, isInsideCarousel }) => {
  return (
    <article
      className={cn([
        'prose prose-sm max-h-[10rem] overflow-auto p-1  px-2 text-left text-[12px] text-grey-100 ',
        {
          'w-60': !isInsideCarousel,
        },
      ])}
    >
      <Markdown
        children={body}
        options={{
          overrides: {
            a: {
              component: ({ children, ...props }) => {
                return (
                  <a
                    {...props}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-start text-primary-dark"
                  >
                    {children}
                    <FdOutload className="ml-1 mt-px h-4 w-4" />
                  </a>
                );
              },
            },
          },
        }}
      />
    </article>
  );
};

export default TextTip;
